export default __webpack_public_path__ + "media/color/shift-511b26aa.svg";